import Vue from "vue";
import App from "./App.vue";
import VueCookie from 'vue-cookie'
import router from './route/index'
import store from './store/store'
import './assets/css/style.css'
import "./registerServiceWorker";
import Toasted from 'vue-toasted';
import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'
import i18n from '@/utils/i18n'
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

Sentry.init({
  dsn: 'https://056d94b3cfe14436998e3cc8e27b9d4a@sentry.services-money91.com/19',
  integrations: [new Integrations.Vue({Vue, attachProps: true})],
});
Sentry.setUser({ "id": VueCookie.get("X-Auth-Id") });


Vue.config.productionTip = false;
Vue.use(VueCookie);
Vue.use(VuePlyr)
Vue.use(Toasted, {
  theme: "bubble",
  duration: 2000,
  // position: 'top-left'
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
